import React from 'react';
import tabletImageSrc from '../../assets/images/slide/digital-memoir-tablet.png';
import styles from './ProductSlideContentV3.css';

const PARAGRAPHS = [
    'This is your story, in one place. Childhood and school, first jobs, first love, family, and everything that came after.',
    'It starts small: a street you knew by sound, a kitchen, rules nobody ever explained. Then friendships, decisions that were hard at the time, turns nobody saw coming.',
    'Not a timeline. This is your life in your own words, in chapters that get finished one question at a time. Who reads them, and when, is yours to decide.'
];

function ProductSlideContentV3() {
    return (
        <div className={styles.form}>
            <p className={styles.label}>Your Digital Memoir preview</p>
            <h2 className={styles.title}>You’ve lived a Story Worth telling</h2>
            <div className={styles.imageWrapper}>
                <img src={tabletImageSrc} alt='' className={styles.image} />
            </div>
            <div className={styles.about}>
                <p className={styles.aboutTitle}>About your Memoir</p>
                {PARAGRAPHS.map(paragraph => (
                    <p key={paragraph} className={styles.paragraph}>{paragraph}</p>
                ))}
            </div>
        </div>
    );
}

export {
    ProductSlideContentV3
};
